import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output,} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators,} from "@angular/forms";
import {ToastService} from "maps-angular-components";
import {BehaviorSubject, Subscription} from "rxjs";
import {map} from "rxjs/operators";

import {HttpErrorResponse} from "@angular/common/http";
import {GrupoCarteira} from "../grupo-carteira";
import {GrupoCarteiraService} from "../grupo-carteira.service";
import { indicate } from "src/app/shared/util/loading-indicate";

@Component({
  selector: "cadastro-grupo-carteira",
  templateUrl: "./cadastro-grupo-carteira.component.html",
  styleUrls: [
    "./cadastro-grupo-carteira.component.scss",
    "../../shared/form-component.css",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadastroGrupoCarteiraComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  nome: string;

  @Input() grupoCarteira: GrupoCarteira;

  @Input() edit: boolean = false;

  @Output()
  onFormChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  @Output() editado = new EventEmitter();

  form: FormGroup;

  @Input()
  isConsulta = false;

  loading$ = new BehaviorSubject(false);

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly grupoCarteiraService: GrupoCarteiraService,
    private readonly toastService: ToastService
  ) {
  }

  async ngOnInit() {
    this.createForm();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  limparForm() {
    this.createForm();
    this.form.reset();
    this.markAsPending();
  }

  private createForm() {
    this.form = this.formBuilder.group({
      nome: new FormControl(
        {value: null, disabled: this.isConsulta},
        Validators.required
      ),
      descricao: new FormControl(
        {value: null, disabled: this.isConsulta},
      ),
      parametros: new FormGroup({}),
    });

    this.form.valueChanges
      .pipe(map(value => ({...value, funcoes: value.funcoes?.nome})))
      .subscribe(() => {
        this.onFormChange.emit(this.form);
      });

    if (this.grupoCarteira) {
      this.form.get("nome").setValue(this.grupoCarteira.nome);
      this.form.get("descricao").setValue(this.grupoCarteira.descricao);
    }
  }

  markAsPending(): void {
    Object.keys(this.form.controls).forEach((field) => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsPending();
      }
    });
  }

  public gravar() {
    let gc = this.grupoCarteiraService.montarGrupoCarteira(this.form);

    this.gravarGrupoCarteira(gc);
  }

  gravarGrupoCarteira(gc: GrupoCarteira) {
    if (this.edit) {
      gc.id = this.grupoCarteira.id
      this.subscriptions.add(
        this.grupoCarteiraService.updateGrupoCarteira(gc).pipe(indicate(this.loading$)).subscribe(
          () => {
            this.toastService.textoLight("Edição do grupo de carteira enviado para autorização!");
            this.limparForm();
            this.editado.emit();
          },
          (error: HttpErrorResponse) => {
            this.toastService.erro(error.error.message);
          }
        )
      );
    }
    else {
    this.subscriptions.add(
      this.grupoCarteiraService.gravarGrupoCarteira(gc).pipe(indicate(this.loading$)).subscribe(
        () => {
          this.toastService.textoLight("Criação do grupo de carteira enviada para autorização!");
          this.limparForm();
        },
        (error: HttpErrorResponse) => {
          this.toastService.erro(error.error.message);
        }
      )
    );
  }
  }
}
